import graphql from "babel-plugin-relay/macro";
import { useSetAtom } from "jotai";
import { fetchQuery, useRelayEnvironment } from "react-relay";

import { updateRoundTransportationIdAtom } from "@/features/BookingWizard/atoms/actions/updateRoundTransportationId/updateRoundTransportationIdAtom";

import { useSetValidTransportationTypeQuery } from "./__generated__/useSetValidTransportationTypeQuery.graphql";

export const useSetValidTransportationType = () => {
  const environment = useRelayEnvironment();

  const updateRoundTransportationId = useSetAtom(
    updateRoundTransportationIdAtom
  );

  const handleGetValidTransportationType = (
    slotId: string,
    memberId: string,
    transportationTypeId: string,
    playerType?: "MEMBER" | "GUEST" | "CUSTOMER"
  ) => {
    fetchQuery<useSetValidTransportationTypeQuery>(
      environment,
      setValidTransportationTypeQuery,
      {
        slotId,
        memberId,
        playerType,
      }
    )
      .toPromise()
      .then((data) => {
        const matchingTransportationType =
          data?.node?.transportationTypes?.find(
            (transportationType) =>
              transportationType?.id === transportationTypeId
          );

        if (matchingTransportationType) {
          updateRoundTransportationId(memberId, matchingTransportationType.id);
        } else {
          const preferredTransportationType =
            data?.node?.preferredTransportationType;
          if (preferredTransportationType) {
            updateRoundTransportationId(
              memberId,
              preferredTransportationType.id
            );
          }
        }
      });
  };

  return [handleGetValidTransportationType] as const;
};

export const setValidTransportationTypeQuery = graphql`
  query useSetValidTransportationTypeQuery(
    $slotId: ID!
    $memberId: ID
    $playerType: PlayerType
  ) {
    node(id: $slotId) {
      ... on Slot {
        id
        transportationTypes(
          memberId: $memberId
          memberVisible: true
          playerType: $playerType
        ) {
          id
          code
          customCode
          name
          enabled
          nineHolePrice: totalPrice(holeCount: NINE)
          eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)
        }
        preferredTransportationType(
          memberId: $memberId
          memberVisible: true
          playerType: $playerType
        ) {
          id
          code
          enabled
        }
      }
    }
  }
`;
